import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el MegaPack?',
    a: 'Por email en menos de 5 minutos, las 24 horas, los 7 días de la semana.'
  }, {
    q: '¿Sirve para mi país?',
    a: 'Sí. Español neutro, ingredientes universales. Argentina, México, Colombia, Chile, Perú, Uruguay, Venezuela, Guatemala, Bolivia, Ecuador, Paraguay, Costa Rica y todo el mundo hispanohablante.'
  }, {
    q: '¿Sirve para papás y para mamás?',
    a: 'Sí. Lenguaje 100% inclusivo con ejemplos de papás y mamás por igual.'
  }, {
    q: '¿Los 5 bonos están incluidos?',
    a: 'Sí. Siempre. Sin costo adicional junto con los 6 tomos del MegaPack.'
  }, {
    q: '¿Sirve si tengo poco tiempo para cocinar?',
    a: 'Sí. El Tomo 2 es viandas sin cocción. El Tomo 4 resuelve en menos de 15 minutos por día. El Bono 5 tiene combinaciones para días de caos total.'
  }, {
    q: '¿Funciona si mi hijo/hija es selectivo/selectiva?',
    a: 'Sí. El Tomo 3 está dedicado completamente a esta situación con estrategias específicas.'
  }, {
    q: '¿Sirve si solo tengo a mis hijos/hijas algunos días?',
    a: 'Sí. Diseñado para cualquier esquema de custodia: 2 días, 3 días, semana de por medio o cualquier combinación.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio es en USD. El cobro se procesa automáticamente en la moneda de tu país.'
  }, {
    q: '¿Qué diferencia hay con recetas gratis de internet?',
    a: 'El MegaPack no es una colección de recetas. Es un sistema completo: organización, planificación, compras, presupuesto, niños selectivos y herramientas para sostenerlo en el tiempo.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cosmic-deep pt-4 md:pt-6 pb-8 md:pb-12 px-4" data-id="element-98" data-mp="p248wg4x4on8">
      <div className="max-w-3xl mx-auto" data-id="element-99" data-mp="2p3tzeimk1uq1">
        <h2 className="font-display font-bold text-white text-center text-xl md:text-4xl mb-4 md:mb-6" data-id="element-100" data-mp="2p4vm5kcxo5nl">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-101" data-mp="2z1rn950i5pi4">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-[#1C1040] rounded-xl overflow-hidden border border-white/10" data-id="element-102" data-mp="3344pvkjyd7ao" data-mpi={index}>
                <button className="w-full text-left px-3.5 py-2.5 md:px-5 md:py-3 flex items-center justify-between gap-2 focus:outline-none hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} data-id="element-103" data-mp="3d19gbwktzoxa">
                  <span className="font-display font-bold text-white text-[13px] md:text-base leading-snug pr-2" data-id="element-104" data-mp="3qtpdwhuyquqt">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-gold shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} strokeWidth={2.5} data-id="element-105" data-mp="1k4np8m1gtjp9" />
                </button>

                <AnimatePresence initial={false} data-id="element-106" data-mp="1b4sa664sh4jy">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-107" data-mp="165xrr5aqhi0d">
                      <div className="px-3.5 pb-3 pt-1 md:px-5 md:pb-4 text-white/80 text-[12px] md:text-sm leading-snug border-t border-white/10" data-id="element-108" data-mp="2hs5uhmvx43oi">
                        <p className="pt-2" data-id="element-109" data-mp="21f12rc1ea2o1">{faq.a}</p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}